import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {TokenStorageService} from '../../shared/service/token-storage.service';
import {UserRoleEnum} from '../../shared/enums/user-role.enum';
import {ApprovalPending} from '../../shared/dto/approval-pending';
import {ApprovalModel} from '../../shared/dto/approval.model';
import Swal from "sweetalert2";
import {ApprovalService} from '../../service/approval.service';
import {DocumentViewerComponent} from './document-viewer/document-viewer.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {RemarkComponent} from '../remark/remark.component';
import {FwdRemarkComponent} from '../fwd-remark/fwd-remark.component';
import {ReturnRemarkComponent} from '../return-remark/return-remark.component';
import {ApproveChecklistComponent} from '../approve-checklist/approve-checklist.component';
import {ActionMode} from '../../shared/enums/action-mode.enum';

@Component({
  selector: 'app-approval-process-request-viewer',
  templateUrl: './approval-process-request-viewer.component.html',
  styleUrls: ['./approval-process-request-viewer.component.scss']
})
export class ApprovalProcessRequestViewerComponent implements OnInit {
  appRefNo: number;
  userName: string;
  userRole: string;
  type: string;
  DG:string = UserRoleEnum.DG;
  SHO:string = UserRoleEnum.SHO;
  EXM:string = UserRoleEnum.EXM;
  approvalModel: ApprovalModel = new ApprovalModel();

  constructor(private route: ActivatedRoute, private tokenStorageService: TokenStorageService,
              private approvalService: ApprovalService, private modalService: NgbModal) {
    this.route.paramMap.subscribe(params => {
      this.appRefNo = +this.decodeBase64(params.get('id'));
      this.type = params.get('type')
    });
  }

  ngOnInit() {
    this.userName=this.tokenStorageService.getUserObjectToken().username;
    this.userRole=this.tokenStorageService.getUserObjectToken().userroleCode;
  }
  decodeBase64(code: string): string {
    return atob(code);
  }

  rejectRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'Reject';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(RemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
      appType: this.type,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService)
  }

  forwardToDg() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'FWD_DG';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(FwdRemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
      appType: this.type,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService)
  }

  returnRequest() {

    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'RETURN';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(ReturnRemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
      appType: this.type,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }

  approveRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = ActionMode.APPROVE;
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(ApproveChecklistComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
      appType: this.type,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }

}
